import styled from "styled-components";
import { Link } from "gatsby";

export const Accordions = styled.div`
  counter-reset: section;
`;

export const Accordionsitems = styled.div`
  position: relative;
  overflow: hidden;
`;

export const AccordionsContent = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;
  position: relative;

  &.expanded-accordion {
    max-height: 1000px;
    overflow: inherit;
    transition: max-height 0.2s ease-out;
  }
`;

export const AccordionsContentinner = styled.div`
  font-size: 14px;
  line-height: 24px;
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 28px;
  }
  > p {
    font-size: 14px;
    line-height: 24px;
    @media (min-width: 992px) {
      font-size: 16px;
      line-height: 28px;
    }
  }
`;

export const AccordionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AccordionsTitle = styled.div`
  background-color: ${(props) => props.bgColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  color: #fff;
  font-weight: 600;
  padding: 6px 0;
  @media (min-width: 768px) {
    padding: 8px 0;
  }
  font-size: 16px;
  line-height: 28px;
  @media (min-width: 992px) {
    font-size: 18px;
    line-height: 30px;
    padding: 10px 0;
  }
  strong {
    font-weight: 600;
    + span {
      margin-left: 15px;
    }
  }
  span {
    width: 30px;
    min-width: 30px;
    height: 30px;
    position: relative;
    display: inline-block;
    transition: all 0.35s ease;
    margin-left: auto;
    @media (min-width: 576px) {
      margin-right: auto;
      margin-left: 0;
    }
    &:before,
    &:after {
      display: block;
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
    }
    &:before {
      width: 2px;
      height: 50%;
    }
    &:after {
      width: 50%;
      height: 2px;
    }
  }

  &.active {
    span {
      transform: rotate(135deg);
      &:before,
      &:after {
        background: #fff;
      }
    }
  }
`;

AccordionsTitle.defaultProps = {
  bgColor: "transparent",
};

export const ListManufacturer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin: 0 -15px;
`;

export const ListItemManufacturer = styled(Link)`
  display: flex;
  flex-wrap: nowrap;
  color: #ccc;
  &:hover {
    color: #e9242a;
  }
  padding: 5px 15px;
  flex: 0 0 100%;
  max-width: 100%;

  @media (min-width: 440px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (min-width: 660px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .text {
    font-size: 14px;
    line-height: 24px;
    @media (min-width: 992px) {
      font-size: 16px;
      line-height: 26px;
    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    + .text {
      margin-left: 15px;
    }
    > svg {
      fill: #e9242a;
    }
  }
  > a {
    color: #eee;
    &:hover {
      color: #fff;
    }
  }
`;
